import {sortBy, indexOf} from 'lodash';

export function sortByOrderId(orderArray: number[], itemsArray: any[]) {
  return sortBy(itemsArray, item => {
    const index = indexOf(orderArray, item.id);
    if (index === -1) {
      return orderArray.length;
    }
    return index;
  });
}
